import {
    GETCHARGENAME_SUCCESS,
    GETCHARGENAME_FAILED,
    RESET_GETCHARGENAME,
    LOADING_GETCHARGENAME,
    NETWORK_ERROR_GETCHARGENAME
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETCHARGENAME:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case GETCHARGENAME_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case GETCHARGENAME_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_GETCHARGENAME:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_GETCHARGENAME:
            return (state = initialState);
        default:
            return state;
    }
};
